import React from 'react';

interface BusinessInfoProps {
  isWhite: boolean;
}

const BusinessInfo: React.FC<BusinessInfoProps> = ({ isWhite }) => {
  return (
    <div>
      <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.33337 9.5C7.33337 7.61438 7.33337 6.67157 7.91916 6.08579C8.50495 5.5 9.44776 5.5 11.3334 5.5H32.6667C34.5523 5.5 35.4951 5.5 36.0809 6.08579C36.6667 6.67157 36.6667 7.61438 36.6667 9.5V32.5C36.6667 35.3284 36.6667 36.7426 35.788 37.6213C34.9093 38.5 33.4951 38.5 30.6667 38.5H13.3334C10.5049 38.5 9.09073 38.5 8.21205 37.6213C7.33337 36.7426 7.33337 35.3284 7.33337 32.5V9.5Z"
          stroke={isWhite ? "#FFFFFF" : "#33363F"}
          strokeWidth="2"
        />
        <path d="M27.5 33L27.5 38.5M16.5 33L16.5 38.5" stroke={isWhite ? "#FFFFFF" : "#33363F"} strokeWidth="2" strokeLinecap="round" />
        <path d="M16.5 14.6641L27.5 14.6641" stroke={isWhite ? "#FFFFFF" : "#33363F"} strokeWidth="2" strokeLinecap="round" />
        <path d="M16.5 22L27.5 22" stroke={isWhite ? "#FFFFFF" : "#33363F"} strokeWidth="2" strokeLinecap="round" />
      </svg>
    </div>
  );
};

export default BusinessInfo;
